import GastosAdminTab from "./finanzas/GastosAdminTab";

// Fix P (2026-08-31): pantalla de gastos administrativos mensuales, montada
// como página propia de Finanzas (mismo patrón de FinanzasPorObra/Proyectado),
// ruta /finanzas/gastos-admin.
export default function FinanzasGastosAdmin() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6 min-h-full" data-testid="finanzas-gastos-admin-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">Gastos Administrativos</h1>
        <p className="text-sm text-gray-500 mt-0.5">Carga mensual de gastos administrativos reales, por obra o para toda la empresa</p>
      </div>
      <GastosAdminTab />
    </div>
  );
}
